// extracted by mini-css-extract-plugin
export default {"slider-container":"fLt9midsAm_g1CG_J3V1","sliderThumb":"DX4xupxHCQkDvahriBvZ","sliderTrack":"ya64PzhWfnKS7tzQkAX6"};